var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBizCorporation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed7015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eda215"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.75 -7.455)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    transform: "translate(7.75 7.455)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.82,31.808V6.573a1.739,1.739,0,0,0-1.739-1.739H2.06A1.739,1.739,0,0,0,.321,6.573V31.808",
    transform: "translate(-0.321 1.103)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.284,26.648V22.134a.946.946,0,0,1,.946-.946H16.392a.945.945,0,0,1,.945.946v4.514",
    transform: "translate(1.245 6.264)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 5.46,
    transform: "translate(12.556 27.452)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.287,15.172a.458.458,0,0,1-.459-.458V12.3a.457.457,0,0,1,.459-.457H15.7a.457.457,0,0,1,.458.457v2.412a.457.457,0,0,1-.458.458Zm-6.413,0a.457.457,0,0,1-.458-.458V12.3a.457.457,0,0,1,.458-.457H9.282a.46.46,0,0,1,.462.457v2.412a.46.46,0,0,1-.462.458Zm-6.412,0A.458.458,0,0,1,0,14.714V12.3a.458.458,0,0,1,.462-.457H2.87a.457.457,0,0,1,.458.457v2.412a.457.457,0,0,1-.458.458ZM13.287,9.25a.458.458,0,0,1-.459-.459V6.38a.458.458,0,0,1,.459-.458H15.7a.457.457,0,0,1,.458.458V8.791a.458.458,0,0,1-.458.459Zm-6.413,0a.458.458,0,0,1-.458-.459V6.38a.457.457,0,0,1,.458-.458H9.282a.46.46,0,0,1,.462.458V8.791a.461.461,0,0,1-.462.459Zm-6.412,0A.459.459,0,0,1,0,8.791V6.38a.458.458,0,0,1,.462-.458H2.87a.457.457,0,0,1,.458.458V8.791a.458.458,0,0,1-.458.459ZM13.287,3.327a.46.46,0,0,1-.459-.459V.457A.457.457,0,0,1,13.287,0H15.7a.457.457,0,0,1,.458.457V2.868a.459.459,0,0,1-.458.459Zm-6.413,0a.46.46,0,0,1-.458-.459V.457A.457.457,0,0,1,6.874,0H9.282a.46.46,0,0,1,.462.457V2.868a.463.463,0,0,1-.462.459Zm-6.412,0A.461.461,0,0,1,0,2.868V.457A.458.458,0,0,1,.462,0H2.87a.457.457,0,0,1,.458.457V2.868a.459.459,0,0,1-.458.459Z",
    transform: "translate(4.67 9.365)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.551,6.258V1.372A1.052,1.052,0,0,1,4.6.321H19.5a1.052,1.052,0,0,1,1.051,1.051V6.258",
    transform: "translate(0.698 -0.321)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizCorporation);
export default __webpack_public_path__ + "static/media/biz-corporation.406c4902221072f327ff641882286650.svg";
export { ForwardRef as ReactComponent };